var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

import React from 'react';
import PropTypes from 'prop-types';
import Input from './Input';

var Textarea = function (_Input) {
  _inherits(Textarea, _Input);

  function Textarea() {
    _classCallCheck(this, Textarea);

    return _possibleConstructorReturn(this, _Input.apply(this, arguments));
  }

  Textarea.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        path = _props.path,
        debounce = _props.debounce,
        type = _props.type,
        group = _props.group,
        rest = _objectWithoutProperties(_props, ['path', 'debounce', 'type', 'group']);

    var value = this.getValue();

    return React.createElement('textarea', _extends({}, rest, {
      className: this.getClassName(),
      name: path,
      onChange: function onChange() {
        return _this2.onChange.apply(_this2, arguments);
      },
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onKeyPress: this.onKeyPress,
      value: value
    }));
  };

  return Textarea;
}(Input);

Textarea.propTypes = _extends({}, Input.propTypes, {
  disabled: PropTypes.bool,
  className: PropTypes.string
});
export default Textarea;
//# sourceMappingURL=Textarea.js.map